import React, {useMemo} from "react";
import './style.css';
import IMG from "../../constants/image";
import {PATH, PRODUCT_STATUS} from "../../constants";
import {convertUTCToLocal, formatPrice} from "../../utils";
import cn from "classnames";
import {useNavigate} from "react-router-dom";
import IconText from "../Common/Text/IconText";
import ImageBasic from "../Common/Image/ImageBasic";
import {clsx} from "clsx";
import {text} from "../../constants/text";

const ProductItem = ({
                       productDetail,
                       checkUpdateStatus,
                       deleteProduct,
                     }) => {

  const {
    id,
    title,
    thumbnail,
    metadata,
    created_at,
    updated_at,
    status,
    variants_min_price
  } = productDetail || {};
  const {rejected_reason} = metadata || {};
  const navigate = useNavigate();

  const priceText = useMemo(() => {
    if (!variants_min_price) return 'Liên hệ'
    else return formatPrice(variants_min_price)
  }, [variants_min_price]);


  const statusElement = () => {
    if (status === PRODUCT_STATUS.DRAFT) {
      return (
        <div
          className='absolute flex justify-center items-center top-0 left-0 bg-[#F8C51880] text-[10px] rounded-md px-[5px] py-[2px] gap-[5px]'>
          <img className='w-3 h-3' src={IMG.icon.documentCheck} alt="eyeOpenLight"/>
          <p>Đang chờ duyệt</p>
        </div>
      )
    }
    if (status === PRODUCT_STATUS.PROPOSED) {
      return (
        <div
          className='absolute flex top-0 left-0 bg-[#9E9E9E] text-[10px] rounded-md px-[5px] py-[2px] text-white gap-[5px]'>
          <img src={IMG.icon.eyeOffLight} alt="eyeOpenLight"/>
          <p>Đang bị tắt</p>
        </div>
      )
    }
    if (status === PRODUCT_STATUS.REJECTED) {
      return (
        <div className='absolute flex top-0 left-0 text-[10px]'>
          <div
            className='bg-[#E4626F] text-[10px] rounded-l-md px-[5px] py-[2px] text-white gap-[5px]'>
            <IconText
              icon={IMG.icon.ban}
              textSize='text-[10px]'
              iconClass='w-3 h-3'
              text='Bị từ chối'
            />
          </div>
          <div className='bg-[#EDEDED] rounded-r-md px-[5px] py-[2px] gap-[5px]'>
            {`Lý do: ${rejected_reason}`}
          </div>
        </div>
      )
    }
  }

  const renderButtonGroup = () => {
    if (status === PRODUCT_STATUS.PUBLISHED) {
      return (
        <div
          className='flex items-center justify-center bg-transparent border border-[#828282] rounded-2xl w-[100px] py-1 cursor-pointer'
          onClick={() => checkUpdateStatus(productDetail)}
        >
          Tắt sản phẩm
        </div>
      )
    }

    if (status === PRODUCT_STATUS.PROPOSED) {
      return (
        <>
          <div
            className='flex items-center justify-center bg-transparent border border-[#828282] rounded-2xl w-[100px] py-1 cursor-pointer'
            onClick={() => checkUpdateStatus(productDetail)}
          >
            Bật sản phẩm
          </div>
          <div
            className='flex items-center justify-center bg-transparent border border-[#828282] rounded-2xl w-fit md:w-[100px] px-2 md:px-auto py-1 cursor-pointer'
            onClick={() => deleteProduct(productDetail)}
          >
            Xoá
          </div>
        </>
      )
    }

    if (status === PRODUCT_STATUS.REJECTED) {
      return (
        <>
          <div
            className='flex items-center justify-center bg-transparent border border-[#828282] rounded-2xl w-[100px] py-1 cursor-pointer'
            onClick={() => deleteProduct(productDetail)}
          >
            Xoá
          </div>
        </>
      )
    }
  }

  return (
    <div
      className='relative flex flex-col md:flex-row justify-between md:items-center gap-2.5 !pt-7 mt-1 p-0 md:p-5 border-b border-dashed'>
      {statusElement()}
      <div
        className={cn('flex items-center text-xs space-x-[10px] space-y-[10px]', (status === PRODUCT_STATUS.PROPOSED || status === PRODUCT_STATUS.DRAFT) && 'opacity-50')}>
        <div className='min-w-[82px] h-[82px] relative'>
          <ImageBasic className={cn('w-[82px] h-[82px]')} src={thumbnail || IMG.defaultProduct} alt="product"/>
        </div>
        <div className='flex flex-col md:flex-row md:gap-5 justify-between md:items-center'>
          <div className='md:w-80 text-sm'>
            <p>{title || ''}</p>
            <p className='font-bold md:order-last mt-2.5'>{priceText || ''}</p>
          </div>
          <div className='md:flex-col gap-[5px] text-xs text-[#9E9E9E]'>
            <div>{`Ngày đăng: ${convertUTCToLocal(created_at)}`}</div>
            <div>{`Lần chỉnh sửa cuối: ${convertUTCToLocal(updated_at)}`}</div>
          </div>
        </div>
      </div>
      <div
        className={clsx("flex items-center justify-center md:flex-col gap-2.5 text-[12px] md:w-[15%] pb-4", status === PRODUCT_STATUS.DRAFT && 'pr-[7rem] md:pr-0')}>
        <div
          className='flex items-center justify-center bg-transparent border border-[#828282] rounded-2xl w-[100px] py-1 cursor-pointer'
          onClick={() => navigate(`${PATH.EDIT_PRODUCT}/${id}`)}
        >
          <p>{text.EDIT}</p>
        </div>
        {renderButtonGroup()}
      </div>
    </div>
  )
};

export default ProductItem;
